// src/components/Shared/ModalWrapper.jsx
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';

const ModalWrapper = ({
    isOpen,
    onClose,
    children,
    maxWidth = 'max-w-md',
    contentPadding = 'p-4 sm:p-6',
    plain = false,
    containerClassName = ''
}) => {

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') onClose();
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = '';
        };
    }, [isOpen, onClose]);

    return createPortal(
        <AnimatePresence>
            {isOpen && (
                <>
                    {/* Backdrop */}
                    <motion.div
                        key="backdrop"
                        className="fixed inset-0 z-[999] cursor-pointer"
                        style={{ background: 'rgba(0, 0, 0, 0.75)' }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.18, ease: [0.16, 1, 0.3, 1] }}
                        onClick={onClose}
                    />

                    {/* Modal */}
                    <motion.div
                        key="modal-content"
                        className="fixed inset-0 flex items-center justify-center z-[1000] p-3 sm:p-4 pointer-events-none"
                        initial={{ opacity: 0, scale: 0.95, y: -8 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.95, y: -8 }}
                        transition={{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }}
                    >
                        <div
                            className={`w-full ${maxWidth} mx-auto pointer-events-auto`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* 
                                If plain is true, render children directly without outer modal styling.
                                Otherwise, render single container: bg + border + padding.
                            */}
                            {plain ? (
                                children
                            ) : (
                                <div className={`bg-[#0e0e0e] rounded-2xl ${contentPadding} shadow-2xl shadow-black/60 border border-white/[0.06] ${containerClassName}`}>
                                    {children}
                                </div>
                            )}
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>,
        document.body
    );
};

export default ModalWrapper;